// ------------------------------------------------------
// ------------------ Helper Functions ------------------
// ------------------------------------------------------


// See (/scripts/stats-src/common-config/pay-tax/tax-type-breakdown-map.ts) for what format the conversion function and taxTypeObject are expected to be
export const applyConversionFunction = (value, conversionFunction, taxTypeObject) => {
  if (!conversionFunction) {
    return value;
  }
  else {
    if (conversionFunction.method === "lessThan") {
      return lessThanConversionFunction(value, conversionFunction, taxTypeObject);
    }
  }
};

const lessThanConversionFunction = (value, conversionFunction, taxTypeObject) => {
  if (Number(value) < conversionFunction.param) {
    if (conversionFunction.valueIfTrue.key) {
      return taxTypeObject[conversionFunction.valueIfTrue.key]
    }
    else {
      return conversionFunction.valueIfTrue.value;
    }
  }
  else {

    if (conversionFunction.valueIfFalse.key) {
      return taxTypeObject[conversionFunction.valueIfFalse.key]
    }
    else {
      return conversionFunction.valueIfFalse.value;
    }
  }
}






